// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/i18n'; // 记得引入你的 i18n 配置文件
Vue.use(VueRouter)

const routes = [ {
    path: '/',
    name: 'NewHome',
    component: () => import('../views/NewHome.vue'),
    meta: { title: 'metaOption.homepage', hideHeader: true, hideFooter: false, requiresAuth: false }
  },
  {
    path: '/Home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { title: 'metaOption.homepage', hideHeader: false, hideFooter: false, requiresAuth: false }
  },
  {
    path: '/LineType',
    name: 'LineType',
    component: () => import('@/views/LineType.vue'),
    meta: { title: 'metaOption.route_types', hideHeader: false, hideFooter: false, requiresAuth: false }
  },

  {
    path: '/LineList',
    name: 'LineList',
    component: () => import('@/views/LineList.vue'),
    meta: { title: 'metaOption.route_list', hideHeader: false, hideFooter: false, requiresAuth: false }
  },
  {
    path: '/SearchPage',
    name: 'SearchPage',
    component: () => import('@/views/SearchPage.vue'),
    meta: { title: 'metaOption.search_results', hideHeader: false, hideFooter: false, requiresAuth: false }
  },
  {
    path: '/LineDetail',
    name: 'LineDetail',
    component: () => import('@/views/LineDetail.vue'),
    meta: { title: 'metaOption.route_details', hideHeader: false, hideFooter: false, requiresAuth: false }
  },
  {
    path: '/UserPage',
    name: 'UserPage',
    component: () => import('../views/UserPage.vue'),
    meta: { title: 'metaOption.personal_center', hideHeader: true, hideFooter: true, requiresAuth: true }
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: 'metaOption.login_registr', hideHeader: true, hideFooter: true, requiresAuth: false }
  },
  {
    path: '/richTextPage',
    name: 'richTextPage',
    component: () => import('@/views/richTextPage.vue'),
    meta: { title: 'metaOption.Travel', hideHeader: false, hideFooter: false, requiresAuth: false }
  },
]



const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',  // 打包改为 hash 模式
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {

  // 获取登录状态（通常存在 localStorage 或 Vuex/Pinia 中）
  const isLoggedIn = localStorage.getItem('token') // 或者根据你的实际存储方式
  if (to.meta.title) {
    document.title = i18n.t(to.meta.title) // 使用 i18n 进行翻译
  } else {
    document.title = i18n.t('metaOption.defaultTitle') // 你的默认标题
  }
  if (to.query.meta_title) {
    document.title = to.query.meta_title
  }
  // 判断目标路由是否需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要登录但未登录 -> 跳转登录页
    if (!isLoggedIn) {
      next({
        path: '/Login',
        query: { redirect: to.fullPath },// 保存原目标路径，登录后跳回
      })
    } else {
      
      
      next() // 已登录，正常放行
    }
  } else {
    next() // 不需要登录的页面，直接放行
  }
})


export default router